
import {
  computed,
  defineComponent, onMounted, reactive,
  watch,
} from 'vue';
import { Modal } from 'ant-design-vue';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdemProducaoMateriaPrima } from '@/models/Entidades/PCP/IOrdemProducao';
import { IApontamentoMateriaPrima } from '@/models/Entidades/PCP/IApontamentoProducao';
import SelecionarUnidadeProdutoMovimento from '@/components/Cadastros/Produtos/Unidades/SelecionarUnidadeProdutoMovimento.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import ServicoEstoque from '@/servicos/Cadastros/Estoques/ServicoEstoque';
import { IEstoqueItem } from '@/models/Entidades/Cadastros/Estoques/IEstoqueItem';
import { IEstoque } from '@/models/Entidades/Cadastros/Estoques/IEstoque';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import UtilitarioMatematico from '@/core/utilitarios/UtilitarioMatematico';
import { useTelaBase } from '@/core/composables/TelaBase';
import SelecionarProduto from '@/components/Cadastros/Produtos/SelecionarProduto.vue';
import Icone from '@/core/components/Icone.vue';
import { ETipoRastreabilidade } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoRastreabilidade';
import { ETipoLancamentoRastreabilidade } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoLancamentoRastreabilidade';
import { IDTORastreabilidade } from '@/models/DTO/Estoques/Rastreabilidade/IDTORastreabilidade';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { useModalBase } from '@/core/composables/ModalBase';
import SelecaoEstoqueRastreabilidade from '../Estoques/SelecaoEstoqueRastreabilidade.vue';
import { IMovimentoRastreabilidade, IRastreabilidade } from '@/models/Entidades/Estoques/IRastreabilidade';
import { ETipoUsoArma } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoUsoArma';
import ServicoProduto from '@/servicos/Cadastros/Produtos/ServicoProduto';

export default defineComponent({
  name: 'MateriaPrimaEtapaOrdemProducao',
  props: {
    visivel: {
      type: Boolean,
    },
    empresas: {
      type: Array as () => number[],
      required: true,
    },
    materiaPrima: {
      type: Array as () => IOrdemProducaoMateriaPrima[],
      required: true,
    },
    codigoEtapa: {
      type: Number,
      required: true,
    },
    carregando: {
      type: Boolean,
      default: false,
    },
    editavel: {
      type: Boolean,
      default: true,
    },
    editarApontamentoMateriaPrima: {
      type: Boolean,
      default: false,
    },
    statusOrdemProducao: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Icone,
    MensagemSemDados,
    CampoNumerico,
    SelecionarProduto,
    SelecionarUnidadeProdutoMovimento,
    SelecaoEstoqueRastreabilidade,
  },
  emits: ['salvar', 'update:visivel', 'update:carregando', 'update:materiaPrima'],
  setup(props, { emit }) {
    const servicoEstoque = new ServicoEstoque();
    const servicoProduto = new ServicoProduto();
    servicoEstoque.requisicaoSistema();
    const {
      apresentarMensagemAlerta,
      apresentarMensagemErro,
    } = useTelaBase();
    const {
      ocultarBarraProgresso,
    } = useModalBase(props, emit);
    const state = reactive({
      materiaPrima: [] as IOrdemProducaoMateriaPrima[],
      editavel: true,
      etapaSelecionada: 0,
      codigoProdutoSelecionado: -1,
      descricaoSelecionada: '',
      codigoProduto: 0,
      codigoUnidade: 0,
      sigla: '',
      quantidade: 0,
      custoUnitario: 0,
      custoTtoal: 0,
      estoqueItem: {} as IEstoqueItem,
      estoque: {} as IEstoque,
      carregando: true,
      casasDecimais: 0,
      TransferirLote: false,
      exibirRastreabilidade: false,
      codigoSelecionado: 0,
      lancouRastreabilidades: false,
      tipoLancamento: ETipoLancamentoRastreabilidade.Manual,
      codigoItemEstoque: 0,
      estoqueRastreabilidadeUtilizado: [] as IDTORastreabilidade[],
      tipoRastreabilidade: ETipoRastreabilidade.Nenhum,
      selecaoUnica: false,
      edicaoMP: false,
      indexSelecionado: -1,
      exibirCamposCusto: false,
      expandedRows: [] as number[],
      quantidadeAnterior: 0,
    });

    const computedCarregando = computed({
      get: () => props.carregando,
      set: (val: boolean) => {
        emit('update:carregando', val);
      },
    });

    const computedMateriaPrima = computed<IOrdemProducaoMateriaPrima[]>({
      get: (): IOrdemProducaoMateriaPrima[] => props.materiaPrima,
      set: (etapas: IOrdemProducaoMateriaPrima[]) => {
        emit('update:materiaPrima', etapas);
      },
    });

    function validaCampos() {
      if (!UtilitarioGeral.validaCodigo(state.codigoProduto)) {
        apresentarMensagemAlerta('Por favor selecione um produto!');
        return false;
      }
      if (!UtilitarioGeral.validaCodigo(state.codigoUnidade)) {
        apresentarMensagemAlerta('Por favor selecione uma unidade!');
        return false;
      }
      if (!UtilitarioGeral.validaNumerico(state.quantidade)) {
        apresentarMensagemAlerta('Por favor informe uma quantidade!');
        return false;
      }
      if (state.codigoProdutoSelecionado === -1 && computedMateriaPrima.value.some((p) => p.codigoProduto === state.codigoProduto)) {
        apresentarMensagemAlerta('O produto já foi adicionado!');
        return false;
      }
      return true;
    }

    function limparCampos() {
      state.codigoProdutoSelecionado = -1;
      state.codigoProduto = 0;
      state.codigoUnidade = 0;
      state.quantidade = 0;
      state.descricaoSelecionada = '';
      state.sigla = '';
      state.codigoProdutoSelecionado = -1;
      state.casasDecimais = 0;
    }

    async function obterCodigoEstoque(codigoEstoque: number, codigoUnidade: number, codigoProduto: number) {
      state.estoque = {} as IEstoque;
      state.estoque = await servicoEstoque.obter(codigoEstoque, props.empresas[0]);
      state.estoqueItem = await servicoEstoque.obterItemEstoqueInformacoesProduto(codigoEstoque, codigoProduto, codigoUnidade, props.empresas[0]);
    }

    async function atualizarItens(index: number) {
      if (state.estoqueItem.codigo === 0) {
        await obterCodigoEstoque(state.estoque.codigo, state.codigoUnidade, state.codigoProduto);
      }
      if (state.estoqueItem.codigo === 0) {
        apresentarMensagemAlerta('Por favor selecione um estoque!');
        return;
      }
      const definicaoProduto = await servicoProduto.obterDadosDetalhesDefinicao(computedMateriaPrima.value[index].codigoProduto);
      if (definicaoProduto) {
        state.tipoRastreabilidade = definicaoProduto.tipoRastreabilidade;
        state.tipoLancamento = definicaoProduto.tipoLancamentoRastreabilidade;
      }
      computedMateriaPrima.value[index].codigoetapa = state.etapaSelecionada;
      computedMateriaPrima.value[index].codigoProduto = state.codigoProduto;
      computedMateriaPrima.value[index].codigoUnidade = state.codigoUnidade;
      computedMateriaPrima.value[index].quantidade = state.quantidade;
      computedMateriaPrima.value[index].descricao = state.descricaoSelecionada;
      computedMateriaPrima.value[index].siglaUnidade = state.sigla;
      computedMateriaPrima.value[index].custoUnitario = state.custoUnitario;
      computedMateriaPrima.value[index].custoTotal = state.custoTtoal;
      computedMateriaPrima.value[index].transferirLote = state.TransferirLote;
      computedMateriaPrima.value[index].estoque = state.estoque.codigo;
      computedMateriaPrima.value[index].estoqueItem = state.estoqueItem.codigo;
      computedMateriaPrima.value[index].casasDecimais = state.casasDecimais;
      computedMateriaPrima.value[index].tipoRastreabilidade = state.tipoRastreabilidade;
      computedMateriaPrima.value[index].tipoLancamentoRastreabilidade = state.tipoLancamento;
      limparCampos();
    }
    function excluir(index: number) {
      state.materiaPrima.splice(index, 1);
      state.codigoProdutoSelecionado = -1;
    }

    function editar(index: number) {
      state.codigoProdutoSelecionado = index;
    }

    function calculaCustoTotal(index: number, subIndex?: number) {
      if (subIndex !== undefined && subIndex >= 0) {
        const subItem = computedMateriaPrima.value[index].materiasPrimasPI[subIndex];
        subItem.custoTotal = subItem.custoUnitario * subItem.quantidade;
      } else {
        const item = computedMateriaPrima.value[index];
        item.custoTotal = item.custoUnitario * item.quantidade;

        // Recalcula as MPs do Produto Intermediário (PI)
        if (item.produtoIntermediario && Array.isArray(item.materiasPrimasPI)) {
          const anterior = state.quantidadeAnterior;
          const atual = item.quantidade;
          if (anterior > 0 && atual > 0 && anterior !== atual) {
            const proporcao = atual / anterior;
            item.materiasPrimasPI.forEach((pi) => {
              // eslint-disable-next-line no-param-reassign
              pi.quantidade = +(pi.quantidade * proporcao).toFixed(6);
              // eslint-disable-next-line no-param-reassign
              pi.custoTotal = +(pi.custoUnitario * pi.quantidade).toFixed(6);
            });
          }
        }
      }
    }

    async function adicionar(index: number) {
      if (!validaCampos()) { return; }
      if (index > -1) {
        atualizarItens(index);
        return;
      }
      const materiaPrima: IOrdemProducaoMateriaPrima = {} as IOrdemProducaoMateriaPrima;
      if (state.estoqueItem.codigo === 0) {
        await obterCodigoEstoque(state.estoque.codigo, state.codigoUnidade, state.codigoProduto);
      }
      if (state.estoqueItem.codigo === 0) {
        apresentarMensagemAlerta('Por favor selecione um estoque!');
        return;
      }
      const definicaoProduto = await servicoProduto.obterDadosDetalhesDefinicao(state.codigoProduto);
      if (definicaoProduto) {
        state.tipoRastreabilidade = definicaoProduto.tipoRastreabilidade;
        state.tipoLancamento = definicaoProduto.tipoLancamentoRastreabilidade;
      }
      materiaPrima.codigoetapa = state.etapaSelecionada;
      materiaPrima.codigoProduto = state.codigoProduto;
      materiaPrima.codigoUnidade = state.codigoUnidade;
      materiaPrima.quantidade = state.quantidade;
      materiaPrima.descricao = state.descricaoSelecionada;
      materiaPrima.siglaUnidade = state.sigla;
      materiaPrima.custoUnitario = state.custoUnitario;
      const custoTotal = materiaPrima.custoUnitario * materiaPrima.quantidade;
      materiaPrima.custoTotal = UtilitarioMatematico.valorDecimal2Casas(custoTotal);
      materiaPrima.ordem = computedMateriaPrima.value.length + 1;
      materiaPrima.transferirLote = state.TransferirLote;
      materiaPrima.estoque = state.estoque.codigo;
      materiaPrima.estoqueItem = state.estoqueItem.codigo;
      computedMateriaPrima.value.push(materiaPrima);
      limparCampos();
    }

    async function limparUnidade(index: number, subIndex?: number) {
      if (subIndex !== undefined && subIndex >= 0) {
        const subItem = computedMateriaPrima.value[index].materiasPrimasPI[subIndex];
        subItem.codigoUnidade = 0;
        subItem.siglaUnidade = '';
        subItem.casasDecimais = 0;
        const definicaoProduto = await servicoProduto.obterDadosDetalhesDefinicao(subItem.codigoProduto);
        if (definicaoProduto) {
          subItem.tipoRastreabilidade = definicaoProduto.tipoRastreabilidade;
          subItem.tipoLancamentoRastreabilidade = definicaoProduto.tipoLancamentoRastreabilidade;
          subItem.casasDecimais = definicaoProduto.casasDecimais;
          subItem.codigoUnidade = definicaoProduto.codigoUnidade;
        }
      } else {
        const item = computedMateriaPrima.value[index];
        item.codigoUnidade = 0;
        item.siglaUnidade = '';
        item.casasDecimais = 0;
        const definicaoProduto = await servicoProduto.obterDadosDetalhesDefinicao(item.codigoProduto);
        if (definicaoProduto) {
          item.tipoRastreabilidade = definicaoProduto.tipoRastreabilidade;
          item.tipoLancamentoRastreabilidade = definicaoProduto.tipoLancamentoRastreabilidade;
          item.casasDecimais = definicaoProduto.casasDecimais;
          item.codigoUnidade = definicaoProduto.codigoUnidade;
        }
      }
    }

    async function salvarApontamento(index: number) {
      const apontamento : IApontamentoMateriaPrima = {} as IApontamentoMateriaPrima;
      const materiaPrima = computedMateriaPrima.value[index];
      await obterCodigoEstoque(materiaPrima.estoque, materiaPrima.codigoUnidade, materiaPrima.codigoProduto);
      apontamento.codigoOPMateriaPrima = materiaPrima.codigo;
      apontamento.codigoProduto = materiaPrima.codigoProduto;
      apontamento.codigoUnidade = materiaPrima.codigoUnidade;
      apontamento.quantidade = materiaPrima.quantidade;
      apontamento.codigoCentroCusto = state.estoque.codigoCentroCustoPadrao;
      apontamento.codigoEmpresa = state.estoqueItem.codigoEmpresa;
      apontamento.codigoEstoque = materiaPrima.estoque;
      if (computedMateriaPrima.value[index].estoqueItem === 0) {
        computedMateriaPrima.value[index].estoqueItem = state.estoqueItem.codigo;
      }
      computedMateriaPrima.value[index].apontamentosMateriaPrima.push(apontamento);
      state.carregando = false;
    }

    function abrirTelaRastreabilidade() {
      state.lancouRastreabilidades = false;
      state.exibirRastreabilidade = true;
    }

    function PreparaApontamentoMateriaPrimaParaEdicao(index: number, subIndex?: number) {
      let mp: IOrdemProducaoMateriaPrima;
      if (subIndex !== undefined && subIndex >= 0) {
        mp = computedMateriaPrima.value[index].materiasPrimasPI[subIndex];
      } else {
        mp = computedMateriaPrima.value[index];
      }

      state.estoqueRastreabilidadeUtilizado = mp.apontamentosMateriaPrima.map((apontamento) => ({
        codigoItem: 0,
        codigoItemNotaFiscal: 0,
        codigoProdutoDefinicao: apontamento.codigoProduto,
        codigoMovimento: apontamento.codigo,
        codigoEstoque: apontamento.codigoEstoque,
        descricaoEstoque: '',
        descricao: '',
        identificador: apontamento.rastreabilidades?.[0]?.identificador || '',
        quantidade: apontamento.quantidade,
        tipo: apontamento.rastreabilidades?.[0]?.tipo || 0,
        saldo: 0,
        codigoProduto: String(apontamento.codigoProduto),
        descricaoProduto: '',
        unidade: '',
        codigoItemEstoque: apontamento.codigoEstoqueItem,
        codigo: apontamento.rastreabilidades?.[0]?.codigo || apontamento.codigoEstoqueItem,
        numeroLote: apontamento.rastreabilidades?.[0]?.rastreabilidadeLote?.numeroLote || '',
        dataValidade: apontamento.rastreabilidades?.[0]?.rastreabilidadeLote?.dataValidade || '',
        dataFabricacao: apontamento.rastreabilidades?.[0]?.rastreabilidadeLote?.dataFabricacao || '',
        observacao: apontamento.rastreabilidades?.[0]?.observacao || '',
        dataVencimentoFormatada: '',
        dataFabricacaoFormatada: '',
        precoMaximoConsumidor: 0,
        descricaoArmamento: '',
        TipoUsoArma: ETipoUsoArma.UsoPermitido,
        numeroSerieArma: '',
        numeroSerieCano: '',
        casasDecimais: 0,
        qtdSelecionada: apontamento.quantidade,
        qtdAjuste: 0,
        qtdAjustada: 0,
        visivel: true,
        controles: [],

      }));
      state.codigoProdutoSelecionado = mp.codigoProduto;
      state.quantidade = mp.quantidade;
      state.codigoUnidade = mp.codigoUnidade;
      state.edicaoMP = true;
      state.indexSelecionado = index;
      state.tipoRastreabilidade = mp.tipoRastreabilidade || ETipoRastreabilidade.Nenhum;
      state.codigoSelecionado = mp.codigo;
      abrirTelaRastreabilidade();
    }

    async function EditarApontamentoMateriaPrima(estoqueRastUtilizado: IDTORastreabilidade[]) {
      try {
        const mp = computedMateriaPrima.value[state.indexSelecionado];
        if (mp.apontamentosMateriaPrima && Array.isArray(mp.apontamentosMateriaPrima)) {
          const codigosValidos = estoqueRastUtilizado.map((item) => item.codigoMovimento);
          mp.apontamentosMateriaPrima = mp.apontamentosMateriaPrima.filter((apontamento) => codigosValidos.includes(apontamento.codigo));
        }
        estoqueRastUtilizado.forEach((item) => {
          if (item.codigoMovimento === 0) {
            const apontamentoMateriaPrima = {
              codigo: item.codigoMovimento,
              codigoOPMateriaPrima: mp.codigo,
              dataCriacao: UtilitarioData.obterDataAtual(),
              codigoProduto: mp.codigoProduto,
              codigoUnidade: mp.codigoUnidade,
              quantidade: item.qtdSelecionada,
              rastreabilidades: [] as IRastreabilidade[],
              codigoEstoqueItem: item.codigoItemEstoque,
              codigoEmpresa: props.empresas[0],
              codigoEstoque: item.codigoEstoque,
              codigoCentroCusto: 0,
              codigoMovimentoEstoque: 0,
            };
            if (mp.tipoRastreabilidade && mp.tipoRastreabilidade === ETipoRastreabilidade.Lote) {
              const rastreabilidade: IRastreabilidade = {
                codigoItemMovimento: 0,
                codigo: item.codigo,
                codigoItemEstoque: item.codigoItemEstoque,
                identificador: item.identificador,
                descricao: item.descricao,
                dataCriacao: UtilitarioData.obterDataAtual(),
                tipo: ETipoRastreabilidade.Lote,
                rastreabilidadeLote: {
                  codigo: item.codigo,
                  codigoRastreabilidade: item.codigo,
                  numeroLote: item.numeroLote,
                  dataFabricacao: item.dataFabricacao,
                  dataValidade: item.dataValidade,
                  precoMaximoConsumidor: item.precoMaximoConsumidor,
                  densidade: 0,
                  controles: item.controles,
                },
                visivel: true,
                qtdRastreabilidade: item.qtdSelecionada,
                observacao: '',
                movimentoRastreabilidade: {} as IMovimentoRastreabilidade,
                rastreabilidadeArmamento: {
                  codigo: 0,
                  codigoRastreabilidade: 0,
                  descricao: '',
                  tipoUsoArma: ETipoUsoArma.UsoRestrito,
                  numeroSerieArma: '',
                  numeroSerieCano: '',
                },
                origem: {
                  quantidade: item.qtdSelecionada,
                  codigo: 0,
                  codigoRastreabilidade: 0,
                  codigoMovimento: 0,
                  recurso: '',
                },
              };
              apontamentoMateriaPrima.rastreabilidades.push(rastreabilidade);
            }
            if (!mp.apontamentosMateriaPrima) mp.apontamentosMateriaPrima = [];
            mp.apontamentosMateriaPrima.push(apontamentoMateriaPrima);
          } else {
            const index = mp.apontamentosMateriaPrima.findIndex((a) => a.codigo === item.codigoMovimento);
            if (index > -1) {
              mp.apontamentosMateriaPrima[index].codigoEstoqueItem = item.codigoItemEstoque;
              mp.apontamentosMateriaPrima[index].quantidade = item.qtdSelecionada;
              mp.apontamentosMateriaPrima[index].codigoEstoque = item.codigoEstoque;
              if (mp.tipoRastreabilidade === ETipoRastreabilidade.Lote) {
                mp.apontamentosMateriaPrima[index].rastreabilidades = [];
                const rastreabilidade: IRastreabilidade = {
                  codigoItemMovimento: 0,
                  codigo: item.codigo,
                  codigoItemEstoque: item.codigoItemEstoque,
                  identificador: item.identificador,
                  descricao: item.descricao,
                  dataCriacao: UtilitarioData.obterDataAtual(),
                  tipo: ETipoRastreabilidade.Lote,
                  rastreabilidadeLote: {
                    codigo: item.codigo,
                    codigoRastreabilidade: item.codigo,
                    numeroLote: item.numeroLote,
                    dataFabricacao: item.dataFabricacao,
                    dataValidade: item.dataValidade,
                    precoMaximoConsumidor: item.precoMaximoConsumidor,
                    densidade: 0,
                    controles: item.controles,
                  },
                  visivel: true,
                  qtdRastreabilidade: item.qtdSelecionada,
                  observacao: '',
                  movimentoRastreabilidade: {} as IMovimentoRastreabilidade,
                  rastreabilidadeArmamento: {
                    codigo: 0,
                    codigoRastreabilidade: 0,
                    descricao: '',
                    tipoUsoArma: ETipoUsoArma.UsoRestrito,
                    numeroSerieArma: '',
                    numeroSerieCano: '',
                  },
                  origem: {
                    quantidade: item.qtdSelecionada,
                    codigo: 0,
                    codigoRastreabilidade: 0,
                    codigoMovimento: 0,
                    recurso: '',
                  },
                };
                mp.apontamentosMateriaPrima[index].rastreabilidades.push(rastreabilidade);
              }
            }
          }
        });
        state.estoqueRastreabilidadeUtilizado = [] as IDTORastreabilidade[];
      } catch (erro) {
        if (erro instanceof Error) {
          apresentarMensagemErro(erro.message);
        } else {
          apresentarMensagemErro(String(erro));
        }
        return false;
      } finally {
        ocultarBarraProgresso();
      }
      state.indexSelecionado = -1;
      return true;
    }

    function adicionarMateriaPrimaPadrao() {
      const novaMateriaPrima: IOrdemProducaoMateriaPrima = {
        codigo: 0,
        codigoetapa: props.codigoEtapa,
        codigoProduto: 0,
        codigoUnidade: 0,
        quantidade: 0,
        descricao: '',
        siglaUnidade: '',
        custoUnitario: 0,
        custoTotal: 0,
        ordem: computedMateriaPrima.value.length + 1,
        transferirLote: false,
        estoque: 0,
        estoqueItem: 0,
        casasDecimais: 0,
        apontamentosMateriaPrima: [],
        tipoRastreabilidade: ETipoRastreabilidade.Nenhum,
        tipoLancamentoRastreabilidade: ETipoLancamentoRastreabilidade.Manual,
        lotes: '',
        nomeEstoque: '',
        produtoIntermediario: false,
        materiasPrimasPI: [],
      };
      computedMateriaPrima.value.push(novaMateriaPrima);
    }

    function excluirMateriaPrima(index: number, subIndex?: number): void {
      if (subIndex !== undefined && subIndex >= 0) {
        computedMateriaPrima.value[index].materiasPrimasPI.splice(subIndex, 1);
      } else {
        computedMateriaPrima.value.splice(index, 1);
      }
    }

    async function validarExclusao(index: number, subIndex?: number) {
      let itemParaExcluir: IOrdemProducaoMateriaPrima;
      if (subIndex !== undefined && subIndex >= 0) {
        itemParaExcluir = computedMateriaPrima.value[index].materiasPrimasPI[subIndex];
      } else {
        itemParaExcluir = computedMateriaPrima.value[index];
      }
      if (itemParaExcluir.codigo > 0) {
        Modal.confirm({
          title: 'Confirmação de Exclusão',
          content: 'Deseja realmente excluir esta matéria-prima?',
          okText: 'Sim',
          cancelText: 'Não',
          onOk() {
            excluirMateriaPrima(index, subIndex);
          },
        });
      }
    }

    function toggleExpand(index: number) {
      const rowIndex = state.expandedRows.indexOf(index);
      if (rowIndex > -1) {
        state.expandedRows.splice(rowIndex, 1); // Collapse
      } else {
        state.expandedRows.push(index); // Expand
      }
    }

    function isRowExpanded(index: number) {
      return state.expandedRows.includes(index);
    }

    watch(() => state.codigoProduto, () => {
      state.codigoUnidade = 0;
      state.sigla = '';
    });
    onMounted(async () => {
      if (state.carregando) {
        state.carregando = false;
      }
    });

    watch(() => computedMateriaPrima.value, (newVal) => {
      if (newVal) {
        state.expandedRows = newVal
          .map((item, index) => (item.materiasPrimasPI && item.materiasPrimasPI.length > 0 ? index : -1))
          .filter((index) => index !== -1);
      }
    }, { deep: true, immediate: true });

    return {
      props,
      state,
      EPermissaoDados,
      ECustomRenderRow,
      editar,
      excluir,
      computedCarregando,
      salvarApontamento,
      computedMateriaPrima,
      UtilitarioGeral,
      UtilitarioMascara,
      calculaCustoTotal,
      limparCampos,
      useTelaBase,
      apresentarMensagemAlerta,
      adicionar,
      limparUnidade,
      EditarApontamentoMateriaPrima,
      PreparaApontamentoMateriaPrimaParaEdicao,
      ETipoRastreabilidade,
      adicionarMateriaPrimaPadrao,
      atualizarItens,
      excluirMateriaPrima,
      validarExclusao,
      toggleExpand,
      isRowExpanded,
    };
  },
});
